module.exports = __webpack_public_path__ + "img/imageadv.png";